module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "设备编号"
    },
    model: {
      value: (_vm.filters.id),
      callback: function($$v) {
        _vm.filters.id = _vm._n($$v)
      },
      expression: "filters.id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "设备名"
    },
    model: {
      value: (_vm.filters.deviceName),
      callback: function($$v) {
        _vm.filters.deviceName = $$v
      },
      expression: "filters.deviceName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "请选择设备状态"
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.filters.status = $$v
      },
      expression: "filters.status"
    }
  }, _vm._l((_vm.statusOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "请选择设备管理员"
    },
    model: {
      value: (_vm.filters.administrator),
      callback: function($$v) {
        _vm.filters.administrator = $$v
      },
      expression: "filters.administrator"
    }
  }, _vm._l((_vm.deviceAdministrators), function(item) {
    return _c('el-option', {
      key: item.uid,
      attrs: {
        "label": item.name,
        "value": item.uid
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getPageDevices(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.formattedDevices,
      "height": "500"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "设备编号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deviceName",
      "label": "设备名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "formattedAdministrator",
      "label": "设备管理员"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "location",
      "label": "存放地"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "价格",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "formattedStatus",
      "label": "状态",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "250"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.handleDel(scope.row)
            }
          }
        }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "info"
          },
          on: {
            "click": function($event) {
              _vm.checkLoans(scope.row)
            }
          }
        }, [_vm._v("查看借用记录")])]
      }]
    ])
  })], 1)], _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.getPageDevices
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editFormTtile
    },
    on: {
      "close": function($event) {
        _vm.resetForm('editForm')
      }
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "100px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设备名",
      "prop": "deviceName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.deviceName),
      callback: function($$v) {
        _vm.editForm.deviceName = $$v
      },
      expression: "editForm.deviceName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备管理员",
      "prop": "administrator"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择设备管理员"
    },
    model: {
      value: (_vm.editForm.administrator),
      callback: function($$v) {
        _vm.editForm.administrator = $$v
      },
      expression: "editForm.administrator"
    }
  }, _vm._l((_vm.deviceAdministrators), function(item) {
    return _c('el-option', {
      key: item.uid,
      attrs: {
        "label": item.name,
        "value": item.uid
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "存放地",
      "prop": "location"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.location),
      callback: function($$v) {
        _vm.editForm.location = $$v
      },
      expression: "editForm.location"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价格",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.editForm.price),
      callback: function($$v) {
        _vm.editForm.price = $$v
      },
      expression: "editForm.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择状态"
    },
    model: {
      value: (_vm.editForm.status),
      callback: function($$v) {
        _vm.editForm.status = $$v
      },
      expression: "editForm.status"
    }
  }, _vm._l((_vm.statusOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.editSubmit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnEditText))])], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fd5fa9b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/device/device.vue
// module id = 534
// module chunks = 1